var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.userMenu.options)?_c('div',{staticClass:"user-navigation"},[_c('dropdown-user',{attrs:{"selected":_vm.userMenu.selected,"options":_vm.userMenu.options}}),_vm._v(" "),_c('dropdown-language',{attrs:{"selected":_vm.languageMenu.selected,"options":_vm.languageMenu.options}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }